export function isValidPassword(password: string): boolean {
  const passwordValidator = /((?=.*\d)(?=.*[a-zA-Z])(?=.*[\W]).{8,})/
  return passwordValidator.test(password)
}

const hasEightCharacters = (pw: string) => pw.length >= 8
const hasOneDigit = (pw: string) => /\d/.test(pw)
const hasLowerCase = (pw: string) => /[a-zA-Z]/.test(pw)
const hasSpecialCharacter = (pw: string) => /[\W]/.test(pw)

export function subvalidators(pw: string) {
  return {
    hasEightCharacters: hasEightCharacters(pw),
    hasDigit: hasOneDigit(pw),
    hasLowerCase: hasLowerCase(pw),
    hasSpecialCharacter: hasSpecialCharacter(pw),
  }
}
